function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Path, {
  d: "M11.188 15.356a4.168 4.168 0 110-8.335 4.168 4.168 0 010 8.335zm7.224-1.984a.696.696 0 01.469-.456l2.032-.587a10.102 10.102 0 000-2.659l-2.032-.585a.7.7 0 01-.469-.457c-.139-.433-.3-.83-.487-1.19a.69.69 0 01.009-.653L18.95 4.93a9.85 9.85 0 00-1.88-1.88l-1.854 1.016a.698.698 0 01-.654.007 7.808 7.808 0 00-1.192-.487.693.693 0 01-.454-.468l-.587-2.03a10.125 10.125 0 00-2.659 0l-.585 2.03a.694.694 0 01-.455.469c-.44.142-.835.302-1.19.487a.695.695 0 01-.654-.007L4.93 3.05a9.715 9.715 0 00-1.881 1.88l1.017 1.854a.695.695 0 01.008.654 7.688 7.688 0 00-.488 1.19.694.694 0 01-.469.456l-2.03.586a10.094 10.094 0 00.001 2.66l2.03.586a.697.697 0 01.469.454c.14.437.302.833.488 1.192a.695.695 0 01-.008.654L3.05 17.07a9.757 9.757 0 001.881 1.88l1.855-1.016a.696.696 0 01.653-.008c.359.186.756.347 1.191.487.22.071.391.247.455.469l.586 2.03a10.117 10.117 0 002.658.001l.587-2.031a.695.695 0 01.454-.469c.435-.14.832-.3 1.194-.488a.691.691 0 01.652.01l1.854 1.015a9.738 9.738 0 001.88-1.88l-1.016-1.854a.692.692 0 01-.009-.654c.187-.36.348-.756.487-1.19z",
  stroke: "#5B41F0",
  strokeWidth: 1.2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
});

function SvgIconNetwork(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgIconNetwork;